import {
  GET_OWNER_PENDING,
  GET_OWNER_SUCCESS,
  GET_OWNER_ERROR,
  POST_OWNER_PENDING,
  POST_OWNER_SUCCESS,
  POST_OWNER_ERROR,
  PUT_OWNER_PENDING,
  PUT_OWNER_SUCCESS,
  PUT_OWNER_ERROR,
  DELETE_OWNER_PENDING,
  DELETE_OWNER_SUCCESS,
  DELETE_OWNER_ERROR,
  OWNER_DATA,
  SET_OWNER_MODAL,
} from "../../../actions/master-data/owner";

const initialState = {
  pending: false,
  error: null,
  data: null,
  detailData: null,
  isOpenModal: false,
  modalType: "",
};

const owner = (state = initialState, action) => {
  switch (action.type) {
    case GET_OWNER_PENDING:
      return {
        ...state,
        pending: true,
      };
    case GET_OWNER_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case GET_OWNER_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case POST_OWNER_PENDING:
      return {
        ...state,
        pending: true,
      };
    case POST_OWNER_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case POST_OWNER_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case PUT_OWNER_PENDING:
      return {
        ...state,
        pending: true,
      };
    case PUT_OWNER_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case PUT_OWNER_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case DELETE_OWNER_PENDING:
      return {
        ...state,
        pending: true,
      };
    case DELETE_OWNER_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case DELETE_OWNER_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case OWNER_DATA:
      return {
        ...state,
        detailData: action.data,
      };
    case SET_OWNER_MODAL:
      return {
        ...state,
        isOpenModal: action.data.isOpen,
        modalType: action.data.modalType,
      };
    default:
      return state;
  }
};

export default owner;
